import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aed2253a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Sort by")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Value", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Sort by")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Added Date", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(_ctx.$style.options)
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selectOption', {sortBy: 'content',sortOrder: 'asc'}))),
      class: _normalizeClass($props.options.sortBy === 'content' ? _ctx.$style.selected : null)
    }, _hoisted_3, 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selectOption', {sortBy: 'dateAdded',sortOrder: 'asc'}))),
      class: _normalizeClass($props.options.sortBy === 'dateAdded' ? _ctx.$style.selected : null)
    }, _hoisted_6, 2)
  ], 2))
}